// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"955944ed","453":"52634718","796":"c86b2fe8"}[chunkId] + ".chunk.js";
};